<template>
  <div class="">
    <header-portrate />
    <exports-print ref="exportbar" />
    <div>
    <bread-crumbs :items='items'/>
    <TabsComp :tabs="tabs" />
    <v-row class="mainrow mt-2 mb-2" :style="`margin-inline-start:2px;direction:`+lang.dir+`;margin-top:-8px !important;`">
      <v-row class="mt-5">
        <v-col cols="12" md="12">
          <form autocomplete="off">
            <div class="searchTop">
              <div class="searchBar">
                <div>
                  <div class="mobileFont">{{lang.chose_from_list}} {{lang.start_date}}</div>
                  <b-input-group>
                    <b-form-select class="inborder text-center" style="width:33%;background:#efefef;" v-model="sd.day" :options="daysList"/>
                    <b-form-select class="inborder text-center" style="width:33%;background:#efefef;border-right:none !important;" v-model="sd.month" :options="monthsList" />
                    <b-form-select class="inborder text-center" style="width:34%;background:#efefef;" v-model="sd.year" :options="yearsList" />
                  </b-input-group>
                </div>

                <div>
                  <div class="mobileFont">{{lang.chose_from_list}} {{lang.end_date}}</div>
                  <b-input-group>
                    <b-form-select class="inborder text-center" style="width:33%;background:#efefef;" v-model="ed.day" :options="daysList"/>
                    <b-form-select class="inborder text-center" style="width:33%;background:#efefef;border-right:none !important;" v-model="ed.month" :options="monthsList" />
                    <b-form-select class="inborder text-center" style="width:34%;background:#efefef;" v-model="ed.year" :options="yearsList" />
                  </b-input-group>
                </div>

                <div class="noInMobile">
                  <div class="mobileFont">{{lang.mobile}}</div>
                  <b-form-input class="inborder" v-model="mobile" style="background:#efefef;" />
                </div>
                <div>
                  <div class="mobileFont">{{lang.path_number}}</div>
                  <b-form-input class="inborder" v-model="path_number" />
                </div>
                <div>
                  <div class="mobileFont">{{lang.cardid}}</div>
                  <b-form-input class="inborder" v-model="cardid" style="background:#efefef;width:75px;" />
                </div>

                <div>
                  <div class="mobileFont">{{lang.plate_number}}</div>
                  <div class="plateNumber" v-if="$store.state.licenseType.SeparatePlate">
                    <b-form-input class="inborder plateText" v-model="pl.c1" style="background:#fff700 !important;" />
                    <b-form-input class="inborder plateText" v-model="pl.c2" style="border-inline:none !important;background:#fff700 !important;" />
                    <b-form-input class="inborder plateText" v-model="pl.c3" style="border-inline-end:none !important;background:#fff700 !important;" />
                    <b-form-input class="inborder plateNumbers" v-model="pl.text" style="background:#fff700 !important;width:60px;" />
                  </div>
                  <b-form-input
                    v-model="plateNumberco" v-else class="inborder" />
                </div>

                <div class="noInMobile">
                  <div class="mobileFont">{{lang.chose_from_list}} {{lang.customer_type}}</div>
                  <b-input-group>
                    <b-form-select
                      class="selborder"
                      v-model="customer_type"
                      :options="customerTypes"
                      ></b-form-select>
                      <b-input-group-append :style="`margin-${lang.algin}:-20px;margin-top:5px;`">
                          <i class="fas fa-arrow-down"></i>
                      </b-input-group-append>
                  </b-input-group>
                </div>

                <div class="SupStatus noInMobile">
                  <div class="mobileFont">{{lang.chose_from_list}} {{lang.superVisor}}</div>
                  <b-input-group>
                    <b-form-select
                      class="selborder"
                      v-model="superVisor"
                      :options="super_visors"
                      ></b-form-select>
                      <b-input-group-append :style="`margin-${lang.algin}:-20px;margin-top:5px;`">
                          <i class="fas fa-arrow-down"></i>
                      </b-input-group-append>
                  </b-input-group>
                </div>
                
                <div>
                  <div class="mobileFont">{{lang.chose_from_list}} {{lang.status}}</div>
                  <b-input-group>
                    <b-form-select
                      class="selborder"
                      v-model="status"
                      :options="statuses"
                      ></b-form-select>
                      <b-input-group-append :style="`margin-${lang.algin}:-20px;margin-top:5px;`">
                          <i class="fas fa-arrow-down"></i>
                      </b-input-group-append>
                  </b-input-group>
                </div>
                <div>
                  <div>&nbsp;</div>
                  <b-button variant="light" style="padding-top:2px !important; padding-bottom:2px !important;background:blue;color:#fff;width:75px;" class="btnMobile"  @click="getCurrentCards()">{{lang.search}}</b-button>
                </div>
              </div>
              <div style="margin-inline-end:17px;">
                <b-button
                v-if="lang.langname == 'ar'"
                    v-b-toggle.add_new_card
                    class="btn-sm btn addMobile"
                    @click="resetAllValues()"
                    style="margin-top:9px;background:transparent;border:none !important;margin-left:-7px !important;"
                    id="multiply-button" 
                  >
                    <div :class="`multiply-button-content-`+lang.lalgin" style="width:150px;border:none !important">{{lang.add_maint_request}}</div>
                </b-button>
                <b-button
                    v-if="lang.langname == 'en'"
                    v-b-toggle.add_new_card
                    class="btn-sm btn addMobile"
                    @click="resetAllValues()"
                    style="margin-top:9px;background:transparent;border:none !important;margin-left:-7px !important;"
                    id="multiply-button" 
                  >
                    <div :class="`multiply-button-content-`+lang.lalgin" style="width:150px;border:none !important">{{lang.add_maint_request}}</div>
                </b-button>
              </div>
            </div>
          </form>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" :style="`direction:${lang.dir};padding-inline-end:30px;`" v-if="cardStatus.length != 0">
          <v-simple-table>
            <thead>
              <tr>
                <th class="backBlack text-center" v-for="(item,index) in cardStatus" :key="index" style="width:14%">{{ item[`name_${lang.langname}`] }}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="text-center" v-for="(item,index) in cardStatus" :key="index">{{ item.number }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-col>
        <v-col cols="12" :style="`padding-`+lang.lalgin+`:35px;direction:` + lang.dir + `;margin-top:-5px;`">
          <v-data-table
              :headers="headers"
              :items="tablerows"
              :search="search"
              :items-per-page="15"
              width="100%"
              id="MainTable"
              hide-default-footer
              hide-default-header
              fixed-header
          >
          <template slot="body.prepend">  
              <tr>
                  <td v-for="(iHead, indHead) in headers" :key="indHead" 
                    :class="iHead.class + ` text-center `" style="border:1px solid #000 !important;"
                  >
                    {{ iHead.text }}
                  </td>
                </tr>
                <tr>  
                  <td style="font-size:.1rem !important;background:#fff !important;border-inline :none !important;border-top:1px solid #000 !important;" :colspan="tblColspan">&#32;</td>
                  <td style="font-size:.1rem !important;background:#fff !important;border-inline :none !important;border-bottom :2px solid #bbb !important;border-top:1px solid #000 !important;">&#32;</td>
                </tr>
            </template>
            <template v-slot:item="row">
              <tr>
                <td style="width:50px">{{ row.item.path_number }}</td>
                <td style="width:50px">{{ row.item.cardid }}</td>
                <td nowrap class="text-center" :style="`width:80px;background:${row.item._customer_type_bgcolor} !important;color:${row.item._customer_type_color} !important;`">{{ row.item['_customer_type_'+lang.langname] }}</td>
                <!-- <td nowrap style="width:100;">{{ row.item.card_type }}</td>
                <td nowrap style="width:100;">{{ (row.item.old_invoice == 0 ? "-" : row.item.old_invoice ) }}</td> -->
                <td nowrap style="width:100;">{{ row.item.superVisor }}</td>
                <td nowrap style="width:100;">{{ row.item.po_number_ }}</td>
                <td nowrap>{{ row.item.customer }}</td>
                <td>{{ row.item.mobile }}</td>
                <td nowrap>{{ row.item.received_date.substring(0,10) }}</td> 
                <td nowrap>{{ row.item.delivery_date ? row.item.delivery_date.substring(0,10) : '-' }}</td>
                <td nowrap>{{ row.item.plate_number }}</td>
                <td nowrap>{{ row.item.model }}</td>
                <td nowrap v-if="$store.state.licenseType.showCardNums">{{ row.item.temp_expense }}</td> 
                <td style="" v-if="$store.state.licenseType.showCardNums">{{ row.item.total }}</td>
                <td v-if="$store.state.licenseType.showCardNums">{{ row.item.vat }}</td>
                <td style="" v-if="$store.state.licenseType.showCardNums">{{ row.item.ftotal }}</td>
                <td style="" v-if="$store.state.licenseType.showCardNums">{{ $RoundNums(parseFloat(row.item.temp_expense) + parseFloat(row.item.ftotal),2) }}</td>
                <td style="" v-if="$store.state.licenseType.showCardNums">{{ row.item.paid }}</td>
                <td style="" v-if="$store.state.licenseType.showCardNums && row.item.remaining < 1">{{ 0 }}</td>
                <td style="" v-if="$store.state.licenseType.showCardNums && row.item.remaining >= 1">{{ row.item.remaining }}</td>
                <td style="text-align:center;background:red !important;color:#fff !important;" v-if="$store.state.licenseType.showCardNums && row.item.remaining != 0">{{ lang.card_not_paid }}</td>
                <td style="text-align:center;background:green !important;color:#fff !important;" v-if="$store.state.licenseType.showCardNums && row.item.remaining == 0">{{ lang.card_paid }}</td>
                <td :style="`text-align:center;background:`+row.item._invoiced_bg+` !important;color:`+row.item._invoiced_color+` !important;width:100px !important;font-weight:bolder !important`">{{ row.item['_invoiced_'+lang.langname] }}</td>
                <td :style="`text-align:center;background:`+row.item._statusbg+` !important;color:`+row.item._statuscolor+` !important;width:100px !important;font-weight:bolder !important`">{{ row.item['_status_'+lang.langname] }}</td>
                <td
                    style="
                      cursor: pointer;
                      width: 85px;
                      border: 1px solid #bbb !important;
                    "
                    class="backBlue text-center"
                  >
                  <div v-b-toggle.popViewCard @click="ViewItem(row.item)">
                    {{lang.view}}</div> 
                </td>
              </tr>
            </template>
            <template slot="body.append">
                    <tr>  
                      <td style="font-size:.1rem !important;background:#fff !important;border:none !important;" :colspan="tblColspan">&#32;</td>
                      <td style="font-size:.1rem !important;background:#fff !important;border-inline:none !important;border-top:1px solid #bbb !important;">&#32;</td>
                    </tr>
                    <tr class="black--text tfoot" v-if="$store.state.licenseType.showCardNums">
                        <!-- <td class="backEmpty"></td>
                        <td class="backEmpty"></td> -->
                        <td class="backEmpty"></td>
                        <td class="backEmpty"></td>
                        <td class="backEmpty"></td>
                        <td class="backEmpty"></td>
                        <td class="backEmpty"></td>
                        <td class="backEmpty"></td>
                        <td class="backBlack" style="font-size:1.2em;text-align:center;">{{lang.totals}}</td>
                        <td class="backBlack" style="font-size:1.2em;text-align:center;">{{ sumField('temp_expense') }}</td>
                        <td class="backBlack" style="font-size:1.2em;text-align:center;">{{ sumField('total') }}</td>
                        <td class="backBlack" style="font-size:1.2em;text-align:center;">{{ sumField('vat') }}</td>
                        <td class="backBlack" style="font-size:1.2em;text-align:center;">{{ sumField('ftotal') }}</td>
                        <td class="backBlack" style="font-size:1.2em;text-align:center;">{{ $RoundNums(parseFloat(sumField('ftotal')) + sumField('temp_expense'),2) }}</td>
                        <td class="backBlack" style="font-size:1.2em;text-align:center;">{{ sumField('paid') }}</td>
                        <td class="backBlack" style="font-size:1.2em;text-align:center;">{{ sumField('remaining') }}</td>
                        <td class="backEmpty" style="font-size:1.2em;text-align:center;"></td>
                        <td class="backEmpty"></td>
                        <td class="backEmpty"></td>
                    </tr>
            </template>
          </v-data-table>
          
        </v-col>
        <v-col cols="12" style="margin-bottom:25px;margin-top:-15px;">
          <v-container>
            <div class="text-center pt-2">
              <v-pagination
                v-model="page"
                value="10"
                :length="pageCount"
                color="#000"
                @input="getNext(page)"
              ></v-pagination>
            </div>
          </v-container>
        </v-col>
      </v-row>
    </v-row>
      <addNewCard ref="createnew" />

    </div>
    <popViewCard ref="viewCard" />
    <Footer />
    <div class="loadingPage" v-if="$store.state.showLoading">
      <v-progress-circular
          :width="3"
          color="green"
          indeterminate
      ></v-progress-circular>
      </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import addNewCard from "@/components/addNewCard.vue"
  import BreadCrumbs from '@/components/breadCrumbs.vue'
  import HeaderPortrate from '@/components/Header-Portrate.vue'
  import Footer from '@/components/Footer.vue'
  import popViewCard from '@/components/popViewCard.vue'
  import ExportsPrint from '@/components/exports-print.vue'
  import TabsComp from '@/components/tabsComp.vue'
  import {SnotifyPosition} from 'vue-snotify'
  
  export default Vue.extend({
    name: 'Home',

    components: {
        addNewCard,
        BreadCrumbs,
        HeaderPortrate,
        Footer,
        popViewCard,
        ExportsPrint,TabsComp
    },
    data() {
      return {
        path_number: "",
        plateNumberco: '',
        customer_type: 0,
        pl: {
          c1: '',
          c2: '',
          c3: '',
          text: ''
        },
        superVisor: 0,
        cpage: 0,
        showLoading: false,
        status: 0,
        cardStatus: [],
        workersList: [],
        cardid: '',
        selected:1,
        vin:'',
        dBgcolor:'',
        search: '',
        drow: false,
        page: 1,
        pageCount:0,
        // sdate: '',
        // edate: '',
        mobile: '',
        excel_fields:{},
        
        tablerows: [
          
        ],
        ishome: true,
        loading: false,
        sd: {
          day: 1,
          month: (new Date()).getMonth() + 1,
          year: (new Date()).getFullYear(),
        },
        ed: {
          day: (new Date()).getDate(),
          month: (new Date()).getMonth() + 1,
          year: (new Date()).getFullYear(),
        },
        allSupers: []
      }
    },
    created() {
      this.getStartDate();
      this.getCurrentCards();
      // setInterval(() => {this.getCurrentCards();},20000)
      this.getExcelHead();
      setTimeout(() => this.iamin(),100);
      this.compOpj()
    },
    methods: {
      compOpj()
      {
        // alert()
        const obj1 = this.$store.state.lang.en;
        const obj2 = this.$store.state.lang.ar;
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);

        // Find keys unique to obj1
        const uniqueToObj1 = keys1.filter(key => !keys2.includes(key));

        // Find keys unique to obj2
        const uniqueToObj2 = keys2.filter(key => !keys1.includes(key));
        console.log("obj1", uniqueToObj1);
        console.log("obj2", uniqueToObj2);
        return {
            uniqueToObj1,
            uniqueToObj2
        }
        
      },
      collectSearch(){
          return {
              module: 'jobCard',
              elements: {
                  sdate: this.sdate,
                  edate: this.edate,
                  mobile: this.mobile,
                  cardid: this.cardid,
                  plate_number: this.palte_number,
                  superVisor: this.superVisor,
                  status: this.status
              }
          }
      },
      resetAllValues(){
        this.$refs.createnew.resetValues();
        this.$refs.createnew.getInvSettings();
        this.$refs.createnew.$refs.firstCar.images = '';
      },
      getStartDate(){
        let d = (new Date()).getDate();
        let m = (new Date()).getMonth() + 1;
        let y = (new Date()).getFullYear();
        if(parseInt(d) < 30){
          d = parseInt(30) - parseInt(d);
          if(parseInt(m) == 1){
            m = 12
            y = parseInt(y) 
          }
          else if(parseInt(m) > 1){
            m = parseInt(m) - 1;
          }
        }else if(parseInt(d) == 30){
          d = 1;
        }else{
          d = parseInt(d) - parseInt(30);
        }
        this.sd.day = 1;
        this.sd.month = 1;
        this.sd.year = y;
      },
      preparedata(){
        let exdata = {
            list: "cardList",
            title: 'أوامر التشغيل',//this.lang.invoices,
            data: [],
        }
        for(let i=0;i<this.tablerows.length;i++){
            exdata.data.push(this.tablerows[i]);
        }
        // // console.log(exdata);
        this.$refs.exportbar.exportdata = exdata;
        this.$refs.exportbar.sdate = this.sdate;
        this.$refs.exportbar.edate = this.sdate;
        
        this.$refs.exportbar.exporttitle = "";
        this.$refs.exportbar.palte_number = '';
        this.$refs.exportbar.contact_number = '';
      },
      resetAll(){
        // this.$refs.createnew.resetALl();
      },
      iamin(){
        if("params",typeof this.$route.params.select !== 'undefined'){
          this.changeBck(this.$route.params.doit);
          this.selected = this.$route.params.select;
          this.getCurrentCards();
        }else{
          this.changeBck(1)
        }
      },
      changeBck(i){
        // this.sdate = '';
        // this.edate = '';
        // this.mobile = '';
        // this.plate_number = '';
        // if(i == 1){
        //   document.getElementById('underwork').style.backgroundColor = '#000000';
        //   document.getElementById('underwork').style.color = '#fff';
        //   document.getElementById('latecard').style.backgroundColor = '#eee';
        //   document.getElementById('latecard').style.color = '#000';
        //   document.getElementById('closedcard').style.backgroundColor = '#eee';
        //   document.getElementById('closedcard').style.color = '#000';
        //   document.getElementById('underwork').innerHTML = this.lang.new + '&nbsp;&nbsp;<i class="fas fa-arrow-down"></i>';
        //   document.getElementById('closedcard').innerHTML = this.lang.closed;
        //   document.getElementById('latecard').innerHTML = this.lang.late;
        // }else if(i == 2){
        //   document.getElementById('underwork').style.backgroundColor = '#eee';
        //   document.getElementById('underwork').style.color = '#000';
        //   document.getElementById('latecard').style.backgroundColor = '#eee';
        //   document.getElementById('latecard').style.color = '#000';
        //   document.getElementById('closedcard').style.backgroundColor = '#000000';
        //   document.getElementById('closedcard').style.color = '#fff';
        //   document.getElementById('underwork').innerHTML = this.lang.new;
        //   document.getElementById('closedcard').innerHTML = this.lang.closed + '&nbsp;&nbsp;<i class="fas fa-arrow-down"></i>';
        //   document.getElementById('latecard').innerHTML = this.lang.late;
        // }else if(i == 3){
        //   document.getElementById('underwork').style.backgroundColor = '#eee';
        //   document.getElementById('underwork').style.color = '#000';
        //   document.getElementById('latecard').style.backgroundColor = '#000000';
        //   document.getElementById('latecard').style.color = '#fff';
        //   document.getElementById('closedcard').style.backgroundColor = '#eee';
        //   document.getElementById('closedcard').style.color = '#000000';
        //   document.getElementById('underwork').innerHTML = this.lang.new;
        //   document.getElementById('closedcard').innerHTML = this.lang.closed ;
        //   document.getElementById('latecard').innerHTML = this.lang.late+ '&nbsp;&nbsp;<i class="fas fa-arrow-down"></i>';
        // }
      },
      getExcelHead(){
        const head = this.headers;
        
        // for(var i=0;i< head.length;i++){
        //   const x = head[i].text;
        //   const y = head[i].value;
        //   this.excel_fields[x] = y;
        // }
        
      },
      gotoDaily(){
        this.$router.push({path: '/reports/daily-reports'})
      },
      PrintPage(){
        window.print();
      },
      sumField(key) {
        let x = this.tablerows.reduce((a, b) => parseFloat(a) + (parseFloat(b[key]) || 0), 0);
        x = +x *100;
        x = (Math.round(x)/100);
        if(x != 0) return x;
        else return 0;
      },
      async ViewItem(item){
        this.$refs.viewCard.cardid = item.cardid;
        await this.$refs.viewCard.getCard(item.cardid);
      },
      getNext(page){
        this.cpage = parseInt(page) - 1;
        this.getCurrentCards();
      },
      getCurrentCards(){
        const ds = new Date(this.sdate);
        const de = new Date(this.edate);
        if(ds.getTime() > de.getTime()){
            let message = "يجب ان يكون تاريخ البدء اقل من او يساوي تاريخ الانتهاء";
            this.$snotify.error(message, 'تنبيه', {
                timeout: 1000000,
                showProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                position: SnotifyPosition.centerCenter,
                buttons: [
                    {
                        text: this.lang.close, 
                        action: (toast) => {
                            this.$snotify.remove(toast.id); 
                        } 
                    },
                ]
            });
            this.invoice.payment.cash = this.full_ftotal
            if(this.invoice.payment.cash == 0) this.invoice.payment.cash = '';
            return false;
        }
        let cook = this.$cookies.get(this.$store.state.COOKIEPhase);
        const path = this.$router.currentRoute.path;
        let post = new FormData();
        post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
        if(path == "/home1"){
          this.selected = 3;
        }
        post.append('type','getNewCardslist'); 
        post.append('auth',cook);
        post.append('lang',this.$cookies.get(this.$store.state.LangCooki))
        let data = {
          datatype: 'all',
          sdate: this.sdate,
          edate: this.edate,
          mobile: this.mobile,
          plate_number: this.plate_number,
        };
        post.append('data[datatype]',data.datatype);
        post.append('data[sdate]',data.sdate);
        post.append('data[edate]',data.edate);
        post.append('data[mobile]',data.mobile);
        post.append('data[cpage]',this.cpage);
        post.append('data[plate_number]',this.plate_number);
        post.append('data[cardid]',this.cardid);
        post.append('data[status]',this.status);
        post.append('data[superVisor]',this.superVisor);
        post.append('data[customer_type]',this.customer_type);
        post.append('data[path_number]',this.path_number);
        // post.append('data[status]',this.selected);
        // this.tablerows = [];
        this.$store.state.showLoading = true;
        this.loading = true;
        axios.post(
          this.$store.state.SAMCOTEC.r_path,
          post
        ).then((response) => {
          this.$store.state.showLoading = false;
          const res = response.data;
          this.allSupers = res.results.all_supers;
          this.tablerows = res.results.data;
          this.cardStatus = res.results.cards;
          this.loading = false;
          this.pageCount = parseInt(parseInt(res.results.allres) / 15) + 1
          this.page = parseInt(this.cpage) + 1
        })
      },
      ExportToExcel(){
        //
      },
      
    },
    computed: {
      customerTypes: function(){
        return [
          {text: 'الكل', value: 0},
          {text: 'فردي', value: 1},
          {text: 'شركة', value: 2},
          {text: 'حكومي', value: 3}
        ]
      },
      plate_number: function(){
        if(this.$store.state.licenseType.SeparatePlate){
          if(this.pl.c1 == '' && this.pl.c2 == '' && this.pl.c3 == ''  && this.pl.text == ''){
            return '';
          }
          return this.pl.c1 + " " + this.pl.c2 + " " + this.pl.c3 + " " + this.pl.text
        }else{
          return this.plateNumberco
        }
        
      },
      tblColspan:function(){
        return 17;
      },
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                return this.$store.state.lang.en;
                }else{
                return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        statuses: function(){
          let t = [{text: 'الكل',value: 0}];
          Object.keys(this.cardStatus).forEach((key) => {
            t.push({
              text: this.cardStatus[`${key}`][`name_${this.lang.langname}`],value: key
            })
          })
          return t;
        },
        sdate: function() {
          return (new Date(this.sd.year,this.sd.month-1, this.sd.day+1)).toISOString().substring(0,10);
        },
        edate: function() {
          return (new Date(this.ed.year,this.ed.month-1, this.ed.day+1)).toISOString().substring(0,10);
        },
        yearsList: function(){
          const start_year = this.$store.state.licenseType.startYear;
          let t = [{text: this.lang.year, value: -1}];
          for(let i=0;i<100;i++){
            if(parseInt(start_year) + i <= (new Date()).getFullYear()){
              t.push({text: start_year + i, value: start_year+i})
            }
            
          }
          return t
        },
        super_visors: function(){
          let t = [{text: 'الكل' , value: 0}]
          for(let i=0;i<this.allSupers.length;i++){
            t.push({text: this.allSupers[i].full_name, value: this.allSupers[i].id})
          }
          return t;
        },
        daysList: function(){
          return [
            {text: this.lang.day, value: -1},
            {text: 1, value: 1},
            {text: 2, value: 2},
            {text: 3, value: 3},
            {text: 4, value: 4},
            {text: 5, value: 5},
            {text: 6, value: 6},
            {text: 7, value: 7},
            {text: 8, value: 8},
            {text: 9, value: 9},
            {text: 10, value: 10},
            {text: 11, value: 11},
            {text: 12, value: 12},
            {text: 13, value: 13},
            {text: 14, value: 14},
            {text: 15, value: 15},
            {text: 16, value: 16},
            {text: 17, value: 17},
            {text: 18, value: 18},
            {text: 19, value: 19},
            {text: 20, value: 20},
            {text: 21, value: 21},
            {text: 22, value: 22},
            {text: 23, value: 23},
            {text: 24, value: 24},
            {text: 25, value: 25},
            {text: 26, value: 26},
            {text: 27, value: 27},
            {text: 28, value: 28},
            {text: 29, value: 29},
            {text: 30, value: 30},
            {text: 31, value: 31},
          ]
        },
        monthsList: function(){
          return [
            {text: this.lang.chose_month, value: -1},
            {text: 1, value: 1},
            {text: 2, value: 2},
            {text: 3, value: 3},
            {text: 4, value: 4},
            {text: 5, value: 5},
            {text: 6, value: 6},
            {text: 7, value: 7},
            {text: 8, value: 8},
            {text: 9, value: 9},
            {text: 10, value: 10},
            {text: 11, value: 11},
            {text: 12, value: 12},
          ]
        },
        headers: function() {
          let t= [
            {
              text: this.lang.path_number,
              align: 'center',
              filterable: false,
              value: 'cardid',
              sortable: false,
              class: 'pa-0 backBlack'
            },
            {
              text: "#",
              align: 'center',
              filterable: false,
              value: 'cardid',
              sortable: false,
              class: 'pa-0 backBlack'
            },
            {
              text: this.lang.customer_type,
              align: 'center',
              filterable: false,
              value: 'customer',
              sortable: false,
              class: 'pa-0 backBlack'
            },
            // {
            //   text: this.lang.card_type,
            //   align: 'center',
            //   filterable: false,
            //   value: 'customer',
            //   sortable: false,
            //   class: 'pa-0 backBlack'
            // },
            // {
            //   text: this.lang.old_invoice,
            //   align: 'center',
            //   filterable: false,
            //   value: 'customer',
            //   sortable: false,
            //   class: 'pa-0 backBlack'
            // },
            {
              text: this.lang.superVisor,
              align: 'center',
              filterable: false,
              value: 'customer',
              sortable: false,
              class: 'pa-0 backBlack'
            },
            {
              text: this.lang.po_number,
              align: 'center',
              filterable: false,
              value: 'customer',
              sortable: false,
              class: 'pa-0 backBlack'
            },
            {
              text: this.lang.customer_name,
              align: 'center',
              filterable: false,
              value: 'customer',
              sortable: false,
              class: 'pa-0 backBlack'
            },
            {
              text: this.lang.mobile,
              align: 'center',
              filterable: false,
              value: 'mobile',
              sortable: false,
              class: 'pa-0 backBlack'
            },
            {
              text: this.lang.received,
              align: 'center',
              filterable: false,
              value: 'sdate',
              sortable: false,
              class: 'pa-0 backBlack'
            },
            {
              text: this.lang.delivered,
              align: 'center',
              filterable: false,
              value: 'ddate',
              sortable: false,
              class: 'pa-0 backBlack'
            },
            {
              text: this.lang.plate_number,
              align: 'center',
              filterable: false,
              value: 'ddate',
              sortable: false,
              class: 'pa-0 backBlack'
            },
            {
              text: this.lang.car_model,
              align: 'center',
              filterable: false,
              value: 'ddate',
              sortable: false,
              class: 'pa-0 backBlack'
            },
          ]
          if(this.$store.state.licenseType.showCardNums){
            t.push({
              text: this.lang.temporary_expenses,
              align: 'center',
              filterable: false,
              value: 'parts',
              sortable: false,
              class: 'pa-0 backBlack'
            })
            t.push({
              text: this.lang.sales_total,
              align: 'center',
              filterable: false,
              value: 'ftotal',
              sortable: false,
              class: 'pa-0 backBlack'
            })
            
            t.push({
              text: this.lang.sales_vat,
              align: 'center',
              filterable: false,
              value: 'vat',
              sortable: false,
              class: 'pa-0 backBlack'
            })
            t.push({
              text: this.lang.sales_ftotal,
              align: 'center',
              filterable: false,
              value: 'ftotal',
              sortable: false,
              class: 'pa-0 backBlack'
            })
            t.push({
              text: this.lang.all_total,
              align: 'center',
              filterable: false,
              value: 'ftotal',
              sortable: false,
              class: 'pa-0 backBlack'
            })
            t.push({
              text: this.lang.paid,
              align: 'center',
              filterable: false,
              value: 'paid',
              sortable: false,
              class: 'pa-0 backBlack'
            })
            t.push({
              text: this.lang.remain,
              align: 'center',
              filterable: false,
              value: 'remaining',
              sortable: false,
              class: 'pa-0 backBlack'
            })
            
            t.push({
              text: this.lang.card_paid_status,
              align: 'center',
              filterable: false,
              value: 'remaining',
              sortable: false,
              class: 'pa-0 backBlack'
            })
          }
          t.push(
            {
              text: this.lang.isbilled,
              align: 'center',
              filterable: false,
              value: '',
              sortable: false,
              class: 'pad-0 backBlack'
            }
          )
          t.push(
            {
              text: this.lang.status,
              align: 'center',
              filterable: false,
              value: '',
              sortable: false,
              class: 'pad-0 backBlack'
            }
          )
          t.push(
            {
              text: this.lang.action,
              align: 'center',
              filterable: false,
              value: '',
              sortable: false,
              class: 'pad-0 backBlue'
            }
          )
          return t;
        },
      items:function() {
          let title = this.$store.state.hometitle;
          const lang = this.$cookies.get(this.$store.state.LangCooki);
          if(lang == "en"){
            title = this.$store.state.hometitle_en;
          }
          return {
            text: title,
            disabled: true,
            href: '/home',
          }
      },
      xstatus: function() {
        return [
          {
              value: 1,
              text: this.lang.inprogress
          },
          {
              value: 3,
              text: this.lang.closed
          },
          {
              value: 2,
              text: this.lang.not_invoiced
          },
        ]
      },
      tabs: function() {
          const menu = this.$store.getters['state'].menu;
          
            const license = this.$store.getters['state'].licenseType.activemenu;
            const alicense = this.$store.getters['state'].licenseType
            let currentMenu = menu[license];
            // console.log("menu",this.$store.getters['state'].licenseType)
            if(!license){
              return false;
            }
            let cMenu = {main: {},sub:[]};
            Object.values(currentMenu).forEach(value =>{
            const cM = localStorage.getItem('currentMenu');
            if(value.main.index == cM){
                cMenu = value.sub;
            }else if(cM == null && value.main.index == 1){
                cMenu = value.sub;
            }
            });
        
            let t = []
            Object.values(cMenu).forEach(value =>{
            
                if(this.$route.path == value.href){
                    value.class = "mytab";
                }else{
                    value.class = "mytab4";
                }
                if(this.lang.langname == 'ar'){
                    value.name = value.arname
                }else{
                    value.name = value.enname
                }
                for(let i =0; i< value.groupid.length;i++){
                    if(value.groupid[i] == this.$store.getters['state'].group_id){
                    if(alicense[value.perms[0]] || value.perms[0] == 'any')
                        t.push(value)
                    }
                }
            
            })
        
            return t;
      }
    },
  })
</script>
<style>
.v-data-table-header__icon{
  display:none !important;
}
.outsearch{
  color:green;
  border:1px solid #ccc;
}
thead th, tfoot th, .tfoot th{
  background: #efefef !important;
  color:#000 !important;
  border:1px solid #000 !important;
  font-size:12px;
  white-space: nowrap;
}
thead th a , thead th i, thead th i a{
  color:#FFF !important;
  white-space: nowrap;
}
tbody td{
  font-size:12px;
  color:#000 !important;
  white-space: nowrap;
  border:1px solid #000;
}
.v-breadcrumbs{
  padding:12px !important;
}
.v-tab--active{
  background:#ccc;
  color:#FFF;
}
.v-tabs-slider-wrapper a{
  color:#FFF !important;
}
tfoot th{
  border:1px solid #000;
}
.close svg {
    width: 74px !important;
    height: 34px !important;
    color: #FFF;
    background: red;
}
header button.close {
    width: 24px !important;
    height: 24px !important;
}
input{
  box-shadow: none !important;
}
button:active,button:focus{
  box-shadow: none !important;
}
._mybtn{
  font-size:.8rem;
  border:0px solid #fff;
  width:100%;
}
._mybtn2{
  font-size:.8rem;
  background:rgb(15, 212, 230) !important;
  border:0px solid #000;
  width:100%;
}
._mybtn4{
  font-size:.8rem;
  background:rgb(15, 90, 230) !important;
  border:0px solid #fff;
}
._mybtn3{
  font-size:.8rem;
  background:#198754 !important;
  border:0px solid #fff;
}
._mybtn1{
  font-size:.8rem;
  background:#fe7b33 !important;
  border:0px solid #fff;
}
td,th{
      height: 30px !important;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > tbody > tr > th, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > th, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > th{
  padding: 0 10px !important;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > tbody > tr > th, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > th, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
    padding: 0 10px !important;
}
.viewBTN{
  font-size:.8rem;
  background:blue !important;
  width:100%;
  color:#fff !important;
  height:25px !important;
  margin-left:5px;
  text-align:center;
  display:flex;
  justify-content: center;
  justify-items: center;
  align-items: center;
}
.viewBTN:hover,.viewBTN:active,.viewBTN.viewBTN:click{
  background:blue !important;
  width:100%;color:#fff !important;
}
.backBlue{
  background: blue !important;
  color: #fff !important;
  border-bottom: 1px solid #fff !important;
  border-left: 1px solid #fff !important;
  border-right: 1px solid #fff !important;
}
.backGold{
  background: gold !important;
  color: #000 !important;
  border-bottom: 1px solid #fff !important;
  border-left: 1px solid #fff !important;
  border-right: 1px solid #fff !important;
}
.viewBTN{
  font-size:.8rem;
  background:blue !important;
  width:100%;
  color:#fff !important;
  height:25px !important;
  margin-left:5px;
  text-align:center;
  display:flex;
  justify-content: center;
  justify-items: center;
  align-items: center;
}
.viewBTN:hover,.viewBTN:active,.viewBTN.viewBTN:click{
  background:blue !important;
  width:100%;color:#fff !important;
}
.loadingPage{
  position: fixed;
  left:0;
  right:0;
  top:0;
  bottom: 0;
  display: flex;
  justify-content: center;
  justify-items: center;
  align-items: center;
  background:#ffffff00;
  z-index: 100000;
}
.plateText{
  width:30px !important;
}
.plateNumbers{
  width:60px !important;
}
.SupStatus{
  width:150px;
}
.addMobile{
  width:165px;
}
@media  only screen and (max-width: 1100px){
  .addMobile{
    width:150px;
    white-space:nowrap;
  }
  .mobileFont, .btnMobile, .btn{
    font-size:.65rem;
  }
  .SupStatus{
    width:130px;
  }
  .plateText{
    width:30px !important;
  }
  .plateNumbers{
    width:60px !important;
  }
  .searchBar div{
    margin-inline-end:1px;
  }
  .noInMobile{
    display:none;
  }
}
</style>

